module.exports = __webpack_public_path__ + "static/img/common_indicator_tz.60331314.png";